import { render } from "./EditorialFlairBody.vue?vue&type=template&id=44ec8c0e&scoped=true"
import script from "./EditorialFlairBody.vue?vue&type=script&lang=js"
export * from "./EditorialFlairBody.vue?vue&type=script&lang=js"

import "./EditorialFlairBody.vue?vue&type=style&index=0&id=44ec8c0e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ec8c0e"]])

export default __exports__